import type { ResponderType, Ari, UserOption } from './types.tsx';

const transformResponderTypeToUserOption = (
	userData: ResponderType | undefined | null,
): UserOption => ({
	id: userData?.ari || '',
	name: userData?.name || '',
	avatarUrl: userData?.avatarUrl || '',
});

const validateDefaultValue = (responder: ResponderType | undefined | null): Boolean => {
	if (responder === null || responder === undefined) return false;
	if (!responder.ari || !responder.name) return false;
	return true;
};

export const transformDefaultUserValues = (
	defaultValue: (ResponderType | undefined | null)[] | null,
): UserOption[] => {
	if (defaultValue === null || defaultValue === undefined) return [];
	return defaultValue.filter(validateDefaultValue).map(transformResponderTypeToUserOption);
};

const mapUserOptionToAri = (userData: UserOption): Ari => ({ ari: userData.id });

export const mapUserOptionsToAris = (userData: UserOption[]): Ari[] =>
	userData.map(mapUserOptionToAri);
